import React from "react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";

const DeleteBannerModal = ({
  isOpen,
  onRequestClose,
  banner,
  handleDelete,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={ModalStyle}
      contentLabel="Delete Banner"
    >
      <div className="flex justify-between items-center">
        <h2 className="m-0 text-[20px] text-[#dc2626]">Delete Banner</h2>
        <button
          className="bg-none border-none text-[24px] cursor-pointer text-[#dc2626] transition-colors duration-300 hover:text-[#f33823]"
          onClick={onRequestClose}
        >
          <FaTimes />
        </button>
      </div>
      <p>Are you sure you want to delete this banner?</p>
      <div className="flex justify-end gap-[10px] mt-5">
        <button
          className="py-2 px-4 bg-[#dc2626] text-white rounded-[6px] transition-colors duration-300 hover:bg-[#dc262688]"
          onClick={handleDelete}
        >
          Delete
        </button>
        <button
          className="py-2 px-4 bg-[#ddd] text-[#333] rounded-[6px] transition-colors duration-300 hover:bg-[#ccc]"
          onClick={onRequestClose}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default DeleteBannerModal;

const ModalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.2)",
    backgroundColor: "#fff",
  },
};

Modal.setAppElement("#root");
